import { z } from 'zod';

// In the browser, Zod's eval probe (`Function("")`, used to compile faster parsers) is refused
// by the panel's Content-Security-Policy and only produces a violation report, so it is turned
// off there. Object schemas look this up when they're built, which is why it runs first in
// index.ts, before any schema module. The API on Node keeps the compiled parsers.
if ('document' in globalThis) z.config({ jitless: true });
